import { StyleSheet } from 'react-native';
import { tokens } from '@airtel/air-design-system';
export var getProgressBarItemStyles = (isSmallScreen, isLastItem) => {
  return StyleSheet.create({
    container: {
      marginBottom: isLastItem ? tokens.spacing.SPACING_0 : tokens.spacing.SPACING_16
    },
    title: {
      marginBottom: isSmallScreen ? tokens.spacing.SPACING_4 : tokens.spacing.SPACING_8
    },
    description: {
      marginBottom: tokens.spacing.SPACING_8
    },
    button: {
      marginBottom: tokens.spacing.SPACING_8
    },
    descriptionContainer: {
      flexDirection: 'row',
      alignItems: 'flex-end',
      justifyContent: 'space-between'
    }
  });
};
export var isValidProgressValue = progressValue => {
  return typeof progressValue === 'number';
};